import { render } from "./ShowVideo.vue?vue&type=template&id=71ca8bd5"
import script from "./ShowVideo.vue?vue&type=script&lang=js"
export * from "./ShowVideo.vue?vue&type=script&lang=js"

import "./ShowVideo.vue?vue&type=style&index=0&id=71ca8bd5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__